export default __webpack_public_path__ + "static/media/issue_reporting_solved.ee6366cc.svg";